import { useEffect } from "react";

export default function ScrollToTopOnMount() {
  useEffect(() => {
    window.document.body.scrollTo({ top: 0 });
  }, []);

  return null;
}
